import React from 'react';
import {observer} from 'mobx-react';
import CandidateStatus from './CandidateStatus';
import CandidateTags from './CandidateTags';
import CandidatePositions from './CandidatePositions';
import CandidateRatings from './CandidateRatings';

const FancyFilterSelector = observer(({filterKey, filter, filterUpdated, filterDeleted, Wrapper}) => {
  switch (filterKey) {
    case 'candidate_status':
      return <CandidateStatus filter={filter} filterKey={filterKey} filterUpdated={filterUpdated} filterDeleted={filterDeleted} Wrapper={Wrapper}/>;
    case 'candidate_tags':
      return <CandidateTags filter={filter} filterKey={filterKey} filterUpdated={filterUpdated} filterDeleted={filterDeleted} Wrapper={Wrapper}/>;
    case 'candidate_positions':
      return <CandidatePositions filter={filter} filterKey={filterKey} filterUpdated={filterUpdated} filterDeleted={filterDeleted} Wrapper={Wrapper}/>;
    case 'candidate_ratings':
      return <CandidateRatings filter={filter} filterKey={filterKey} filterUpdated={filterUpdated} filterDeleted={filterDeleted} Wrapper={Wrapper}/>;
    default:
      return null;
  }
});

export default FancyFilterSelector;
